module.exports = __webpack_public_path__ + "static/media/AWC_Brand_light.e5c1ba18.svg";